import styles from './topics-donut.module.scss';
import { Insight } from '@/services/dashboard-service/dashboard.service.types';
import { rankAndFold } from '@/utils/rank';

export type DonutSegment = {
  label: string;
  count: number;
  percent: number;
  color: string;
};

/** Assigned by rank, so a colour belongs to a position rather than to a topic. */
export const DONUT_COLORS = [
  styles.series1,
  styles.series2,
  styles.series3,
  styles.series4,
  styles.series5,
  styles.series6,
  styles.series7,
];

export const DONUT_MAX_SEGMENTS = DONUT_COLORS.length;

/**
 * Ranks topics, caps them at the palette size and colours by position. The list arrives
 * unlimited, so past the cap the remainder is summed into a final segment: losing the
 * tail silently is the one option not available. The fold rule is shared with the topic
 * bars so both screens show the same topics.
 */
export function toDonutSegments(topics: Insight): DonutSegment[] {
  const kept = rankAndFold(topics, DONUT_MAX_SEGMENTS);
  const total = kept.reduce((sum, topic) => sum + topic.count, 0);

  return kept.map((topic, index) => ({
    ...topic,
    percent: total ? (topic.count / total) * 100 : 0,
    color: DONUT_COLORS[index],
  }));
}
